module.exports = __webpack_public_path__ + "static/media/bbq-chicken.060a5400.jpg";